import { ReactNode } from "react";
import IconCheckCircle from "@/app/(components)/generics/Icons/IconCheckCircle";
import PointsLoader from "@/app/(components)/generics/loaders/PointsLoader/PointsLoader";
import styles from "./SourceCard.module.css";

type Props = {
  icon?: ReactNode;
  title: string;
  badge?: string;
  headerAction?: ReactNode;
  description?: string;
  benefits?: string[];
  numberedBenefits?: boolean;
  children?: ReactNode;
  actions?: ReactNode;
  isLoading?: boolean;
};

export default function SourceCard(props: Props) {
  const {
    icon,
    title,
    badge,
    headerAction,
    description,
    benefits,
    numberedBenefits = false,
    children,
    actions,
    isLoading = false,
  } = props;

  if (isLoading) {
    return (
      <div className={styles.card}>
        <div className={styles.loaderBox}>
          <PointsLoader centered color="var(--color-green-3)" />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        {icon && <div className={styles.iconContainer}>{icon}</div>}
        <h3 className={styles.title}>{title}</h3>
        {badge && <span className={styles.badge}>{badge}</span>}
        {headerAction && <div className={styles.headerAction}>{headerAction}</div>}
      </div>

      {description && <p className={styles.description}>{description}</p>}

      {benefits && benefits.length > 0 && (
        <ul className={styles.benefits}>
          {benefits.map((benefit, index) => (
            <li key={index} className={styles.benefit}>
              {numberedBenefits ? (
                <span className={styles.benefitNumber}>{index + 1}</span>
              ) : (
                <IconCheckCircle size={16} />
              )}
              <p>{benefit}</p>
            </li>
          ))}
        </ul>
      )}

      {children}

      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
